import { render } from "./FiltersDialog.vue?vue&type=template&id=4b0dd838&scoped=true"
import script from "./FiltersDialog.vue?vue&type=script&lang=ts"
export * from "./FiltersDialog.vue?vue&type=script&lang=ts"

import "./FiltersDialog.vue?vue&type=style&index=0&id=4b0dd838&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b0dd838"

export default script